import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { parentFind } from "library/tree/index.mjs"
import { PlanRoot } from "library/tree/constants.mjs"
import { getBasePlanId } from "routes/plan/controller/use-plan"
import { If } from "lib/@components/switch"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import { Button } from "@mui/material"
import { confirm } from "lib/@dialogs/confirm"
import { publishPlan, removePlan } from "routes/plan/controller/publish-plan"
import { navigate } from "lib/routes/navigate"
import { PublishClient } from "routes/regime/plugins/publishing/publishing.runtime"
import { busyWhile } from "lib/@components/busy/busy-while"
import { useIsNextRegimeStepDisabled } from "routes/regime/plugins/publishing/hooks/use-is-next-regime-step-disabled"
import { IfTooltip } from "lib/if-tooltip"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_REGIME_DRAFT_LOCKING } from "routes/regime/regime-draft-locking/server/feature-flag-regime-draft-locking.mjs"

export function PublishButton() {
    const { parentItem } = useBoundContext()
    const parent = parentFind(parentItem, (c) => c[PlanRoot])
    const id = getBasePlanId(parent)

    const { disabled, message } = useIsNextRegimeStepDisabled("Review")

    return (
        <If field="activeStep.props.id" equals="Review">
            <PublishClient>
                <Secure demand="publishRegime" hide fallback={<Frag />}>
                    <IfTooltip condition={disabled} title={message}>
                        <Button
                            onClick={publish}
                            size="small"
                            variant="outlined"
                            color="primary"
                            sx={{ mt: 1 }}
                            data-cy="publish-review-to-candidate-btn"
                            disabled={disabled}
                        >
                            Approve Review
                        </Button>
                    </IfTooltip>
                </Secure>
            </PublishClient>
        </If>
    )

    async function publish() {
        if (await confirm("Are you sure you want to approve the current review version?")) {
            await busyWhile(async () => {
                await publishPlan(`publish|${id}`, "ready")
                await removePlan(id, "publish")
                navigate(`/app/schedules?id=ready|${id}`, { replace: true })
            }, "Publishing")
            if (isEnabled(FEATURE_FLAG_REGIME_DRAFT_LOCKING)) {
                successSnackbar("Review approved. A new editable draft is ready")
            }
        }
    }
}
